import React from 'react';
import { useHistory } from 'react-router-dom';
import { IconHide } from '@bynder/icons';
import { EmptyState, Flex } from '@bynder/design-system';
import { Translate } from '@bynder/localization';
import { ROUTES } from '../../constants/app';
import PrimaryButton from '../shared/PrimaryButton';
import { EditModeButton } from '../guides/Header';
import FullScreenContainer from '../shared/styled-components/FullScreenContainer';

const Unpublished: React.FC<{ canEdit: boolean; emptyGuide: boolean }> = ({
  emptyGuide,
  canEdit,
}) => {
  const history = useHistory();

  return (
    <FullScreenContainer>
      <Flex direction="column" justifyContent="center" alignItems="center">
        <EmptyState
          icon={<IconHide />}
          title={
            emptyGuide ? (
              <Translate id="UNPUBLISHED.EMPTY_GUIDE_HEADER_TEXT" />
            ) : (
              <Translate id="UNPUBLISHED.EMPTY_PAGE_HEADER_TEXT" />
            )
          }
          text={
            emptyGuide ? (
              <Translate id="UNPUBLISHED.GUIDE_PARAGRAPH_TEXT" />
            ) : (
              <Translate id="UNPUBLISHED.PAGE_PARAGRAPH_TEXT" />
            )
          }
          actions={
            canEdit ? (
              <EditModeButton />
            ) : (
              <PrimaryButton
                onClick={() => history.push(ROUTES.GUIDE_OVERVIEW)}
              >
                <Translate id="FORBIDDEN.BUTTON_TEXT" />
              </PrimaryButton>
            )
          }
        />
      </Flex>
    </FullScreenContainer>
  );
};

export default Unpublished;
